//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "HumanResources",
  data() {
    return {
      oneLevelVillGroup: [],
      twoLevelVillGroup: [],
      threeLevelVillGroup: [],
      curOneLevelVillGroup: "", // 一级目录
      curTwoLevelVillGroup: "", // 二级目录
      multipleSelection: [],
      dialogVisible: false,
      groupName: "", // 村民小组名称
      dialog: {
        show: false,
        type: "",
      },
      treeProps: {
        label: "groupName",
        isLeaf: "leaf",
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      masterId: "",
    };
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
    formatIsHolder(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "是";
          break;
        case 0:
          result = "否";
          break;
      }
      return result;
    },
  },
  mounted() {},
  methods: {
    /**
     * @descripttion: 加载左侧树形菜单
     * @Author: juanjuanhui
     * @Date: 2022-01-15 11:02:43
     * @param {*} node
     * @param {*} resolve
     */
    async loadNode(node, resolve) {
      let res1 = await this.getOneLevelVillGroup();
      if (node.level === 0) {
        this.oneLevelVillGroup = res1.data;
        res1.data.forEach((item) => {
          item.disabled = true;
        });
        this.defaultExpandedKeys = [res1.data[0].id];
        this.curOneLevelVillGroup = res1.data[0];
        return resolve(res1.data);
      }
      if (node.level > 1) {
        return resolve([]);
      }
      let res2 = await this.getTwoLevelVillGroup({ id: node.data.id });
      res2.data.forEach((item) => {
        item.leaf = true;
      });
      this.twoLevelVillGroup = res2.data;
      this.defaultCheckedKeys = [res2.data[0].id];
      this.curTwoLevelVillGroup = res2.data[0];
      this.getThreeLevelVillGroup({ id: this.curTwoLevelVillGroup.id });
      resolve(res2.data);
    },
    /**
     * @descripttion: 点击树形菜单节点
     * @Author: juanjuanhui
     * @Date: 2022-01-15 11:03:10
     * @param {*} data
     */
    handleNodeClick(data) {
      if (data.organizeLevel != 1) {
        this.curTwoLevelVillGroup = data;
        this.$refs.tree.setCheckedKeys([data.id]);
        this.getThreeLevelVillGroup({ id: data.id });
      }
    },
    /**
     * @descripttion: 获取组织管理一级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getOneLevelVillGroup() {
      return this.$http.village.oneLevelVillGroup({ masterId: this.masterId });
    },
    /**
     * @descripttion: 获取组织管理二级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getTwoLevelVillGroup(params) {
      params.masterId = this.masterId;
      return this.$http.village.twoLevelVillGroup(params);
    },
    /**
     * @descripttion: 获取组织管理三级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getThreeLevelVillGroup(params) {
      let { currentPage, pageSize } = this.pagination;
      params = { ...params, currentPage, pageSize };
      this.$http.village.threeLevelVillGroup(params).then((res) => {
        let { recordTotal, content: threeLevelVillGroup } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.threeLevelVillGroup = threeLevelVillGroup;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getThreeLevelVillGroup({ id: this.curTwoLevelVillGroup[0].id });
    },
    /**
     * @descripttion: 选中或取消选中
     * @Author: juanjuanhui
     * @Date: 2022-01-12 09:55:57
     * @param {*} rows
     * @return {*}
     */
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    /**
     * @descripttion: 获取选中的值
     * @Author: juanjuanhui
     * @Date: 2022-01-12 09:56:23
     * @param {*} val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2022-01-15 20:51:27
     * @param {*} item
     */
    handleLookDetail(item, type) {
      this.$router.push({
        path: "/village/resources-query/human-detail",
        query: {
          id: item.id,
          from_type: type,
        },
      });
    },
  },
  created() {
    this.masterId = this.$route.query.$businessAccountId;
  },
};
